import ProjectCard from "./ProjectCard";
import { projects } from "../data/projects";

const Projects = () => {
  if (!Array.isArray(projects) || projects.length === 0) return null;

  return (
    <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
      {projects.map((project, index) => (
        <ProjectCard
          key={index}
          title={project.title}
          summary={project.front.summary}
          stack={project.front.stack}
          details={project.back.details}
          link={project.back.link}
        />
      ))}
    </div>
  );
};

export default Projects;
